import { Hierarchies } from './hierarchy.model';

export interface SearchResult<T> {
    filters: SearchResultFilter[];
    items: Array<SearchResultItem>;
    query: SearchResultQuery;
    pager: SearchResultPager;
    searchType: string,
    hierarchy: {
        parents: Hierarchies,
        filter: SearchResultFilter,
        scope: Hierarchies
    }
}

export interface SearchResultItem {
    slug: string,
    guid: string,
    cid: string,
    name: string,
    isCommission: boolean,
    description: string,
    minimumOrderQuantity?: number,
    quantityMultiplier?: number,
    quantity: number,
    articleAttributes: [],
    images: [],
    videos: [],
    mainImage: string,
    files: [],
    stock: number,
    hasVolumePrices: boolean,
    inAssortment?: boolean,
    stockLocations: [],
}

export interface SearchResultFilter {
    choices: SearchResultFilterChoice[];
    label: string;
    name: string;
    state: SearchResultFilterState;
}

export interface SearchResultFilterChoice {
    active: boolean;
    count: number;
    label: string;
    urlParameterKey: string;
    urlParameterValue: string;
}
export interface SearchResultQuery {
    name: string;
    state: SearchResultFilterState;
    urlParameters: SearchResultFilterUrlParameters;
}

export interface SearchResultPager {
    currentPage: number;
    itemsPerPage: number;
    maxPages: number;
    numPages: number;
    totalItems: number;
    firstItem: number;
    lastItem: number;
    state: SearchResultFilterState;
}

export interface SearchResultFilterState {
    active: boolean;
    value: string;
}

export interface SearchResultFilterUrlParameters {
    hierarchy: string;
}

export enum SearchTypeEnum {
    ARTICLES = 'articles',
    PRODUCTS = 'products'
}
